import { MapPin, DollarSign, Clock } from "lucide-react";
import InfoCard from "./InfoCard";

interface CourseInfoCardsProps {
  location?: string;
  tuitionFee?: string;
  duration?: string;
  startDate?: string;
}

export default function CourseInfoCards({
  location = "Waterloo, Canada",
  tuitionFee,
  duration,
}: CourseInfoCardsProps) {
  return (
    <div className="flex gap-4 items-start w-full">
      <InfoCard icon={MapPin} heading="Location" value={location} />
      <InfoCard icon={DollarSign} heading="Fees" value={tuitionFee || ""} />
      <InfoCard icon={Clock} heading="Duration" value={duration || ""} />
      {/* <InfoCard icon={Calendar} heading="Next Intake" value={startDate || ""} /> */}
    </div>
  );
}
